import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { LANDING_PAGE_BASE_URL, ITV7_FOOTBALL_TERMS_URL } from '../../config';
import { useTermsAndConditions } from '../../hooks/useTermsAndConditions';
import { isPick7iOSWebView } from '../../utils/authUtils';

const StyledButtonLink = styled.a`
    width: 100%;
`;

export const TermsLinkWrapper = ({ children }) => {
    const { documentUrl } = useTermsAndConditions();
    const isIOS = isPick7iOSWebView();

    if (documentUrl) {
        return (
            <a
                href={documentUrl}
                target={isIOS ? undefined : '_blank'}
                rel="noreferrer"
            >
                {children}
            </a>
        );
    }
    return <>{children}</>;
};

export const Itv7RacingTermsLinkWrapper = ({ children }) => {
    const isIOS = isPick7iOSWebView();
    return (
        <StyledButtonLink
            href={`${LANDING_PAGE_BASE_URL}/terms`}
            target={isIOS ? undefined : '_blank'}
            rel="noopener noreferrer"
        >
            {children}
        </StyledButtonLink>
    );
};

export const Itv7FootballTermsLinkWrapper = ({ children }) => {
    const isIOS = isPick7iOSWebView();
    return (
        <StyledButtonLink
            href={ITV7_FOOTBALL_TERMS_URL}
            target={isIOS ? undefined : '_blank'}
            rel="noopener noreferrer"
        >
            {children}
        </StyledButtonLink>
    );
};

export const RacingButtonLinkWrapper = ({ children }) => {
    return (
        <StyledButtonLink href={`${LANDING_PAGE_BASE_URL}/home`}>
            {children}
        </StyledButtonLink>
    );
};

export const FootballButtonLinkWrapper = ({ children }) => {
    return (
        <StyledButtonLink href={`${LANDING_PAGE_BASE_URL}/football`}>
            {children}
        </StyledButtonLink>
    );
};

TermsLinkWrapper.propTypes = {
    children: PropTypes.node.isRequired
};

Itv7RacingTermsLinkWrapper.propTypes = {
    children: PropTypes.node.isRequired
};

Itv7FootballTermsLinkWrapper.propTypes = {
    children: PropTypes.node.isRequired
};

RacingButtonLinkWrapper.propTypes = {
    children: PropTypes.node.isRequired
};

FootballButtonLinkWrapper.propTypes = {
    children: PropTypes.node.isRequired
};
